// extracted by mini-css-extract-plugin
export var cardsSection = "TransformCard-module--cardsSection--vFU4L";
export var description = "TransformCard-module--description--dbhRc";
export var headerSection = "TransformCard-module--headerSection--4ve9F";
export var title = "TransformCard-module--title--GtDBj";
export var transformCardWrapper = "TransformCard-module--transformCardWrapper--Wpga6";